// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"QuickReplyItem_wrapper__srniu","arrow":"QuickReplyItem_arrow__3ygZ8"};